import cn from 'classnames'
import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import bankIdLogoWhite from './bankid-logo-white.png'

import styles from './button.module.scss'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import Spinner from '../spinner'

interface IButtonProps {
  children: React.ReactNode
  className?: string
  variant?: 'brand' | 'white' | 'dark' | 'success' | 'free' | 'link' | 'gray' | 'pureWhite'
  loading?: boolean
  style?: React.CSSProperties
  outline?: boolean
  block?: boolean
  href?: string
  compact?: boolean
  type?: 'button' | 'submit'
  target?: string
  rel?: string
  disabled?: boolean
  onClick?: () => boolean | void | Promise<void>
  bankId?: boolean
  icon?: IconProp
  tabIndex?: number
}

export default function Button(props: IButtonProps) {
  const {
    children,
    className = '',
    variant = 'brand',
    outline,
    block,
    compact,
    type = 'button',
    bankId,
    icon,
    loading,
    tabIndex,
    ...rest
  } = props

  const Comp = rest.href ? 'a' : 'button'

  return (
    <Comp
      {...rest}
      className={cn(
        styles.root,
        styles[variant],
        outline && styles.outline,
        block && styles.block,
        compact && styles.compact,
        bankId && styles.bankId,
        (props.disabled || props.loading) && styles.disabled,
        className
      )}
      tabIndex={tabIndex || 0}
      type={type}
    >
      {loading ? <Spinner className={styles.spinner} variant="white" /> : children}
      {bankId && <img alt="BankID logo" className={styles.icon} src={bankIdLogoWhite} />}

      {icon && <FontAwesomeIcon className={styles.icon} icon={icon} />}
    </Comp>
  )
}
